import type { RibbonControlProps } from 'owa-acui';
import { owaComputedFn } from 'owa-computed-fn';
import { type MailRibbonControlId, type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import type { RibbonControlId } from 'owa-ribbon-ids';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import { debugErrorThatWillShowErrorPopupOnly } from 'owa-trace';
import { getSyncMailboxControl } from '../../sharedControls/readSharedControlDefinitions';

export const getSLRSendReceiveTabControlDefinition: (
    controlId: RibbonControlId,
    _tabId: MailRibbonTabId,
    props: ReadOnlyRibbonControlDefProps
) => RibbonControlProps | undefined = owaComputedFn(function getSLRSendReceiveTabControlDefinition(
    controlId: RibbonControlId,
    _tabId: MailRibbonTabId,
    props: ReadOnlyRibbonControlDefProps
): RibbonControlProps | undefined {
    switch (controlId) {
        case 701:
            return getSyncMailboxControl(true /* isSLR */, 16, props);
        default:
            debugErrorThatWillShowErrorPopupOnly(
                'getSLRSendReceiveTabControlDefinition UnknownControl: ' + controlId
            );
            return undefined;
    }
});
